import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { useDragLayer } from 'react-dnd';
import { ParticipantMonitoringCard } from './ParticipantMonitoringCard';

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: 280 - theme.marginBase * 2,
    pointerEvents: 'none',
    zIndex: 100,
    cursor: 'grab',
  },
  card: {
    cursor: [['grab', '!important']],
  },
}));

const getItemStyles = (currentOffset: { x: number; y: number } | null) => {
  if (!currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform: transform,
    WebkitTransform: transform,
  };
};

export const CardDragLayer = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const { item, currentOffset, isDragging } = useDragLayer(monitor => ({
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  const style = getItemStyles(currentOffset);
  if (!item || !item.participation || !isDragging) {
    return null;
  }
  return (
    <div className={classes.container} style={style}>
      <ParticipantMonitoringCard
        participation={item.participation}
        className={classes.card}
      />
    </div>
  );
};
